import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";

interface WorkShiftState {
  data: any;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  action: "list" | "update" | "add" | null;
}

const workShiftInitialState: WorkShiftState = {
  data: null,
  loading: "idle",
  error: null,
  action: null,
};

export const add: any = createAsyncThunk(
  "add/work-shift",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.WORK_SHIFT.ADD_NEW, payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);


export const update: any = createAsyncThunk(
  "update/work-shift",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.WORK_SHIFT.UPDATE, payload);
      return response.data;
    } catch (error: any) {
      console.log("error", error?.response);
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);


export const fetchAll: any = createAsyncThunk(
  "list/work-shift",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.WORK_SHIFT.FIND_ALL, payload);
      return response.data;
    } catch (error: any) {

      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);







const workShiftSlice = createSlice({
  name: "reset",
  initialState: workShiftInitialState,
  reducers: {
    resetAll: (state: any) => {
      state.loading = "idle";
      state.error = null;
      state.data = null;
      state.action = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(add.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "add";
    });
    builder.addCase(add.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "add";
    });
    builder.addCase(add.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "add";
    });


    builder.addCase(update.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "update";
    });
    builder.addCase(update.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "update";
    });
    builder.addCase(update.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "update";
    });


    builder.addCase(fetchAll.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(fetchAll.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(fetchAll.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "list";
    });

  }
});
export const { resetAll } = workShiftSlice.actions;
export default workShiftSlice.reducer;
